<template>
  <SeoPage page-key="digitalMarketingStrategieLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'DigitalMarketingStrategieLuganoPage'
})
</script>

